// extracted by mini-css-extract-plugin
export default {"banner":"headerBanner_banner__HW3IA"};